import ApiService from '@/services/api.service'

const ClinicalNotesReportService = {
  getAll(parameter) { 
    const param= {};
    param.DateFrom = parameter.DateFrom;
    param.DateTo = parameter.DateTo;
    param.PatientCodeList = parameter.PatientCodeList;
    param.TherapistCodeList = parameter.TherapistCodeList;
    param.ProgramCodeList = parameter.ProgramCodeList;
    param.TherapiesCodeList = parameter.TherapiesCodeList;
    param.NoteTypeList = parameter.NoteTypeList;
    param.IncludeVoid = parameter.IncludeVoid;
    param.NoteStatusList = parameter.NoteStatusList;
    param.PDFExport = parameter.PDFExport;
    param.PDFNameFormatCode = parameter.PDFNameFormatCode;
    param.PDFNameFormatSelection = parameter.PDFNameFormatSelection;
    param.OrderBy = parameter.OrderBy;
    return ApiService.getWithArray('/ClinicalNotesReport',param);
  },

  monitor(guid){
    return ApiService.get(`/ClinicalNotesReport/Monitor/${guid}`)
  },

  cancel(guid){
    return ApiService.delete(`ClinicalNotesReport/Cancel/${guid}`)
  },
}
  
  export default ClinicalNotesReportService;